export default "__VITE_ASSET__6b0746c9__"